import { gql } from '@moonpig/web-core-graphql'

export const ModuleFacetTileFragment = gql`
  fragment ModuleFacetTile on ModuleFacetTile {
    facetDetails {
      key
    }
    tile {
      title
      url
      image {
        webpUrl: url(width: 148, quality: 80, format: webp)
        defaultUrl: url(width: 148, quality: 80, format: png)
      }
    }
  }
`
